import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from "axios";
import * as echarts from "echarts";
import dataV from '@jiaminghi/data-view'
import '@/styles/index.scss' // global css

import 'normalize.css/normalize.css' // A modern alternative to CSS resets
// import '@/permission' // permission control
// import '../src/icons/index' // icon
import './utils/rem'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import JsonExcel from 'vue-json-excel'


Vue.use(ElementUI);
Vue.use(dataV);
Vue.prototype.axios = axios;
Vue.prototype.$echarts = echarts;
Vue.prototype.$EventBus = new Vue();
Vue.config.productionTip = false;
Vue.component('downloadExcel', JsonExcel)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
//没效果
// ElementUI.Dialog.props.lockScroll.default=false;
